<template>
  <v-card>
    <v-card-title> Data Presensi Siswa </v-card-title>
    <v-card-subtitle>
      <div>
        {{ jurnal_mengajar.tanggal }} /
        {{ jurnal_mengajar.mata_pelajaran.nama }} /
        {{ jurnal_mengajar.rombel.rombel }} /
        {{ jurnal_mengajar.hari.toUpperCase() }} / {{ jurnal_mengajar.ruang }} /
        {{ jurnal_mengajar.jam_kbm_full }}
      </div>
      <div>Pokok bahasan : {{ jurnal_mengajar.pokok_bahasan }}</div>
    </v-card-subtitle>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-text-field
          label="Search"
          v-model="filter.search"
          @change="
            () => {
              options.page = filter.page = 1;
              get();
            }
          "
          append-icon="mdi-magnify"
        ></v-text-field>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'NIS',
            value: 'nis',
          },
          {
            text: 'Nama Siswa',
            value: 'nama',
          },
          {
            text: 'Status Kehadiran',
            value: 'status',
          },
          {
            text: 'Opsi',
            value: 'opsi',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.status" slot-scope="{ item }">
          <v-select
            class="mt-4"
            :items="['masuk', 'sakit', 'izin', 'alpa', 'pulang', 'pkl']"
            :full-width="false"
            dense
            @change="(val) => updatePresensi(item, val)"
            :value="item.presensi"
          >
          </v-select>
        </template>
        <template slot="item.opsi" slot-scope="{ item }">
          <v-btn
            v-if="item.wali"
            text
            color="green"
            @click="callParent(item)"
            title="Hubungi Orang Tua"
          >
            <v-icon>mdi-whatsapp</v-icon>
            <v-icon>mdi-account</v-icon>
          </v-btn>
          <template v-else> - </template>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      is: {
        loading: true,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      jurnal_id: this.$route.params.id,
      jurnal_mengajar: {},
    };
  },
  created() {
    this.get();
    this.getData();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    getData() {
      this.$root.app.http
        .get("/api/matapelajaran/jurnalmengajar/" + this.jurnal_id)
        .then((res) => {
          this.jurnal_mengajar = res.data;
        });
    },
    get() {
      this.is.loading = true;
      this.filter.jurnal_mengajar_id = this.jurnal_id;
      this.$root.app.http
        .get("/api/siswa/presensi", this.filter)
        .then((res) => {
          this.datas = res.data;
          this.recordsTotal = res.recordsTotal;
          this.is.loading = false;
        });
    },
    updatePresensi(item, val) {
      const req = {
        jurnal_mengajar_id: this.jurnal_id,
        siswa_id: item.id,
        status: val,
      };
      this.is.loading = true;
      if (item.presensi_id) {
        this.$root.app.http
          .put("/api/siswa/presensi/" + item.presensi_id, req)
          .then((res) => {
            if (res.error) {
              this.$root.app.notif(res.message[0], true);
            } else {
              this.$root.app.notif("presensi siswa berhasil diedit");
            }
            this.is.loading = false;
          });
      } else {
        this.$root.app.http.post("/api/siswa/presensi", req).then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.$root.app.notif("presensi siswa berhasil diedit");
          }
          this.is.loading = false;
        });
      }
    },
    async callParent(item) {
      try {
        const res = await fetch(
          this.$root.app.socket_url + "/send-message-to-parent",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              namaOrangTua: item.wali.nama,
              noWhatsapp: item.wali.whatsapp,
              siswa: {
                nama: item.nama,
                nisn: item.nis,
                kelas: item.rombel.rombel,
                keterangan: item.presensi,
              },
            }),
          }
        ).then((res) => res.json());

        this.$root.app.notif(res.message);
      } catch (err) {
        this.$root.app.notif(err.toString(), true);
      }
    },
  },
};
</script>
